export const instructionsStyleDesktop = {
  fontSize: "2.5vh",
  color: "white",
  left: 50,
  top: 50,
  margin: "0px",
  position: "absolute",
} as const;

export const instructionsStyleMobile = {
  fontSize: "3vh",
  color: "white",
  left: 10,
  top: 10,
  margin: "0px",
  position: "absolute",
} as const;
//////////////////////////////////////////
export const instructionsTextStyleDesktop = {
  fontSize: "4vh",
  color: "white",
  margin: "0px",
} as const;

export const instructionsTextStyleMobile = {
  fontSize: "3vh",
  color: "white",
  margin: "0px",
} as const;
//////////////////////////////////////////
export const linksParentStyleDesktop = {
  position: "absolute",
  right: 50,
  top: 50,
  margin: 0,
  height: "14.4vh",
  width: "7vh",
} as const;

export const linksParentStyleMobile = {
  position: "absolute",
  right: 10,
  top: 10,
  margin: 0,
  height: "10.2vh",
  width: "5vh",
} as const;
//////////////////////////////////////////
export const linksChildrenStyleDesktop = {
  display: "inline-block",
  height: "7vh",
  width: "7vh",
  padding: ".1vh",
} as const;

export const linksChildrenStyleMobile = {
  display: "inline-block",
  height: "5vh",
  width: "5vh",
  padding: ".05vh",
} as const;
